var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 930 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M433.5 1.1C283.9 11.5 149.2 92.6 70 220.1c-23.2 37.3-41.4 78.7-52.9 120.4C-13.4 451.2-2.6 568.3 47.6 670c19.1 38.7 37.2 66 67.6 102 3.4 4.1 75.3 97.6 159.6 207.7 91.8 119.9 155.5 202.2 158.8 205.2 18.6 17 44.2 17 62.8 0 3.3-3 67-85.3 158.8-205.2C739.5 869.6 811.4 776.1 814.8 772c30.4-36 48.5-63.3 67.6-102 56.6-114.7 62.9-250.2 17.4-369.5-35.3-92.3-96.7-168.9-179.8-224.2C637.5 21.4 533.6-5.8 433.5 1.1zm55.9 225.4c22.4 2.9 39.8 8.1 60.1 18 55.3 26.8 93.1 75.6 106.2 137.4 2.5 11.6 2.7 14.5 2.8 36.6 0 26.7-1 34.5-7 55.5-16.1 56.1-58.6 103.2-113 125.3-20.1 8.2-36.5 12-59.2 13.9-29.4 2.5-59.3-2.3-87.8-13.9-54.4-22.1-96.9-69.2-113-125.3-6-21-7-28.8-7-55.5.1-22.1.3-25 2.8-36.6 11.2-52.7 40.6-96.5 84.2-125.2 17.7-11.6 43.7-22.7 63.7-27.1 20.9-4.6 46.7-5.8 67.2-3.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.aa04242fa59b3fe51711107e13526b8e.svg";
export { ForwardRef as ReactComponent };